import React, { memo } from "react";
import { PaginationControlProps } from "../../types";
import { classNames } from "helpers";
import { ReactSVG } from "react-svg";

const PaginationControl: React.FC<PaginationControlProps> = (props) => {
  const { pagination, onChangePage } = props;

  if (!pagination || pagination.totalPages === 1) return <></>;

  const hasPreviousPage = pagination.pageNumber > 1;
  const hasNextPage = pagination.pageNumber < (pagination.totalPages ?? 0);
  const hasFirstPage = hasPreviousPage ? true : false;
  const hasLastPage = hasNextPage ? true : false;
  const previousPageNumber = hasPreviousPage ? pagination.pageNumber - 1 : 0;
  const nextPageNumber = hasNextPage ? pagination.pageNumber + 1 : 0;

  const lastPageNumber = pagination.totalPages;

  return (
    <>
      <nav
        className="isolate inline-flex gap-1 -space-x-px rounded-sm  "
        aria-label="Pagination"
      >
        {hasFirstPage && (
          <button
            type="button"
            className={classNames(
              hasFirstPage && "cursor-pointer",
              "relative bg-white rounded border border-gray-300  w-10 h-10 inline-flex items-center justify-center px-1 py-1 text-gray-400 focus:z-20 focus:outline-offset-0 disabled:bg-gray-100 enabled:hover:bg-gray-200"
            )}
            disabled={!hasFirstPage}
            onClick={() => onChangePage(1)}
          >
            <ReactSVG
              src="../media/icons/arrow-left-double.svg"
              className="flex items-center justify-center w-5 h-5 [&_svg]:w-full [&_svg]:h-full"
            />
          </button>
        )}
        {hasPreviousPage && (
          <button
            type="button"
            className={classNames(
              hasPreviousPage && "cursor-pointer",
              "relative bg-white rounded border border-gray-300  w-10 h-10 inline-flex items-center justify-center px-1 py-1 text-gray-400 focus:z-20 focus:outline-offset-0 disabled:bg-gray-100 enabled:hover:bg-gray-200"
            )}
            disabled={!hasPreviousPage}
            onClick={() => onChangePage(pagination.pageNumber - 1)}
          >
            <ReactSVG
              src="../media/icons/arrow-left.svg"
              className="flex items-center justify-center w-5 h-5 [&_svg]:w-full [&_svg]:h-full"
            />
          </button>
        )}
        {hasPreviousPage && (
          <button
            type="button"
            className={classNames(
              hasPreviousPage && "cursor-pointer",
              "relative bg-white rounded border border-gray-300  w-10 h-10 inline-flex items-center justify-center font-bold px-1 py-1 text-gray-400 focus:z-20 focus:outline-offset-0 disabled:bg-gray-100 enabled:hover:bg-gray-200"
            )}
            onClick={() => onChangePage(previousPageNumber)}
          >
            {previousPageNumber}
          </button>
        )}

        <input
          type="number"
          className="relative [-moz-appearance:_textfield] rounded border border-gray-300  w-10 h-10   text-center font-bold inline-flex items-center cursor-default bg-slate-100 py-1  pl-3 pr-3  text-[#344054] focus:outline-none"
          min="1"
          max={pagination.totalPages}
          value={pagination.pageNumber}
          onChange={(e) => onChangePage(e.target.value)}
          disabled={true}
        />

        {hasNextPage && (
          <button
            type="button"
            className={classNames(
              hasNextPage && "cursor-pointer",
              "relative bg-white rounded border border-gray-300  w-10 h-10 inline-flex items-center justify-center font-bold px-1 py-1 text-gray-400 focus:z-20 focus:outline-offset-0 disabled:bg-gray-100 enabled:hover:bg-gray-200"
            )}
            onClick={() => onChangePage(nextPageNumber)}
          >
            {nextPageNumber}
          </button>
        )}
        {hasNextPage && (
          <button
            type="button"
            className={classNames(
              hasNextPage && "cursor-pointer",
              "relative bg-white rounded border border-gray-300  w-10 h-10 inline-flex items-center justify-center px-1 py-1 text-gray-400 focus:z-20 focus:outline-offset-0 disabled:bg-gray-100 enabled:hover:bg-gray-200"
            )}
            disabled={!hasNextPage}
            onClick={() => onChangePage(nextPageNumber)}
          >
            <ReactSVG
              src="../media/icons/arrow-right.svg"
              className="flex items-center justify-center w-5 h-5 [&_svg]:w-full [&_svg]:h-full"
            />
          </button>
        )}
        {hasLastPage && (
          <button
            type="button"
            className={classNames(
              hasLastPage && "cursor-pointer",
              "relative bg-white rounded border border-gray-300  w-10 h-10 inline-flex items-center justify-center px-1 py-1 text-gray-400 focus:z-20 focus:outline-offset-0 disabled:bg-gray-100 enabled:hover:bg-gray-200"
            )}
            disabled={!hasLastPage}
            onClick={() => onChangePage(lastPageNumber)}
          >
            <ReactSVG
              src="../media/icons/arrow-right-double.svg"
              className="flex items-center justify-center w-5 h-5 [&_svg]:w-full [&_svg]:h-full"
            />
          </button>
        )}
      </nav>
    </>
  );
};

export default memo(PaginationControl);
